export default {
  localStorage: {
    languageKey: 'language_key'
  }
}
